import React, { useState } from 'react';
import { Button, Text } from 'src/@vymo/ui/atoms';
import ErrorBoundary from 'src/workspace/errorBoundary';
import styles from '../index.module.scss';

export default function RenderTable({ data = [] }: { data: any }) {
  const [displayedRows, setDisplayedRows] = useState(10);

  if (!data.length) return null;

  const [headers, ...rows]: Array<any> = data;

  const visibleRows = rows.slice(0, displayedRows);

  return (
    <ErrorBoundary
      customMessage={
        <Text type="sublabel" variant="warning">
          Error in table data
        </Text>
      }
    >
      <div className={styles.tableContainer}>
        <div className={styles.tableContainer__tableScroll}>
          <table className={styles.tableContainer__minimalTable}>
            {headers[0] !== 'Key' && (
              <thead>
                <tr>
                  {headers?.map((header) => (
                    <th>
                      <Text semiBold type="sublabel">
                        {header}
                      </Text>
                    </th>
                  ))}
                </tr>
              </thead>
            )}

            <tbody>
              {visibleRows.map((row: any) => (
                <tr>
                  {row.map((cell) => (
                    <td>
                      <Text type="description">{cell}</Text>
                    </td>
                  ))}
                </tr>
              ))}
            </tbody>
          </table>
        </div>

        {displayedRows < rows.length && (
          <Button
            type="text"
            variant="info"
            onClick={() => setDisplayedRows(rows.length)}
            size="small"
            className={styles.tableContainer__viewAllButton}
          >
            View all
          </Button>
        )}
      </div>
    </ErrorBoundary>
  );
}
